module.exports = __webpack_public_path__ + "src/assets/img/selector-stub-domogakov.49c3a380.svg";